import type { MouseEvent } from 'react';
import { X } from 'lucide-react';

interface ImageLightboxProps {
  imageUrl: string;
  onClose: () => void;
  alt?: string;
}

export default function ImageLightbox({ imageUrl, onClose, alt = 'Expanded image' }: ImageLightboxProps) {
  const handleBackdropClick = (event: MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4"
      onClick={handleBackdropClick}
      role="dialog"
      aria-modal="true"
      aria-label="Image preview"
    >
      <div className="relative flex max-h-[80vh] max-w-2xl items-center justify-center">
        <img src={imageUrl} alt={alt} className="max-h-full max-w-full rounded-lg object-contain" />
        <button
          onClick={onClose}
          className="absolute right-4 top-4 rounded-full border border-border bg-card/95 p-2 text-foreground transition-colors hover:bg-card"
          aria-label="Close image"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
}
